// src/utils/culturalPatterns.js

/**
 * Detect cultural name pattern based on name structure and components
 */
export const detectCulturalPattern = (nameEntry) => {
  const fullName = nameEntry.fullName || '';
  const tokens = fullName.split(/\s+/);
  
  // Russian pattern (patronymic indicators)
  const russianPatronymics = ['ovich', 'evich', 'ovna', 'evna'];
  if (tokens.length >= 3 && 
      tokens.some(t => russianPatronymics.some(p => t.toLowerCase().endsWith(p)))) {
    return 'russian';
  }
  
  // Arabic pattern (bin/ibn indicators)
  if (tokens.some(t => ['bin', 'ibn', 'ben', 'al-', 'al'].includes(t.toLowerCase()))) {
    return 'arabic';
  }
  
  // East Asian pattern (typically 2-3 characters total, family name first)
  if (tokens.length <= 2 && fullName.length <= 6) {
    return 'eastAsian';
  }
  
  // Hispanic pattern (multiple last names)
  if (tokens.length >= 4) {
    return 'hispanic';
  }
  
  // Default to Western
  return 'western';
};

/**
 * Get component weights based on cultural pattern
 */
export const getComponentWeights = (culturalPattern) => {
  switch (culturalPattern) {
    case 'russian':
      return {
        firstName: 8,
        middleName: 7,
        lastName: 20,
        positional: 10
      };
    case 'arabic':
      return {
        firstName: 8,
        middleName: 5,
        lastName: 20,
        positional: 8
      };
    case 'eastAsian':
      return {
        firstName: 8,
        middleName: 0,
        lastName: 20,
        positional: 12
      };
    case 'hispanic':
      return {
        firstName: 8,
        middleName: 5,
        lastName: 20,
        positional: 10
      };
    case 'western':
    default:
      return {
        firstName: 8,
        middleName: 4,
        lastName: 20,
        positional: 10
      };
  }
};
